import { BillingDetails } from "store/exhibitors/cartStepper/helper";
import { startCase } from "lodash";
import { BillingDetailsKey } from "store/exhibitors/cartStepper/slice";

const getOrderDescription = (billingDetails: BillingDetails) => {
  let billingDetailsKeys = Object.keys(billingDetails) as BillingDetailsKey[];

  return billingDetailsKeys.reduce((acc, cur, idx, initialArray) => {
    const divider = "; \n";
    const currentDetail = `${startCase(cur)}: ${billingDetails[cur]}`;
    if (idx === initialArray.length - 1) {
      return acc + currentDetail;
    }
    return acc + currentDetail + divider;
  }, "");
};

export const getBankTransferOrderDescription = (
  billingDetails: Pick<BillingDetails, "tradingName" | "name" | "status">
) => {
  let billingDetailsKeys = Object.keys(billingDetails) as (keyof Pick<
    BillingDetails,
    "tradingName" | "name" | "status"
  >)[];

  return billingDetailsKeys.reduce((acc, cur, idx, initialArray) => {
    const divider = "; \n";
    const currentDetail = `${startCase(cur)}: ${billingDetails[cur]}`;
    if (idx === initialArray.length - 1) {
      return acc + currentDetail;
    }
    return acc + currentDetail + divider;
  }, "");
};
export default getOrderDescription;
